import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';

import {
    HistoriqueService,
    HistoriquePopupService,
    HistoriqueComponent,
    HistoriqueDetailComponent,
    HistoriqueDialogComponent,
    HistoriquePopupComponent,
    HistoriqueDeletePopupComponent,
    HistoriqueDeleteDialogComponent,
    historiqueRoute,
    historiquePopupRoute,
    HistoriqueResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...historiqueRoute,
    ...historiquePopupRoute,
];

@NgModule({
    imports: [
        CadensSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        HistoriqueComponent,
        HistoriqueDetailComponent,
        HistoriqueDialogComponent,
        HistoriqueDeleteDialogComponent,
        HistoriquePopupComponent,
        HistoriqueDeletePopupComponent,
    ],
    entryComponents: [
        HistoriqueComponent,
        HistoriqueDialogComponent,
        HistoriquePopupComponent,
        HistoriqueDeleteDialogComponent,
        HistoriqueDeletePopupComponent,
    ],
    providers: [
        HistoriqueService,
        HistoriquePopupService,
        HistoriqueResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensHistoriqueModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/historique/historique.module.ts